module.exports = __webpack_public_path__ + "static/media/icono_excel.327c7ded.png";